import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["content", "button"];
  static values = { lines: { type: Number, default: 3 } };

  connect() {
    this.expanded = false;
    this.setLineClamp();
    this.checkIfClampingNeeded();
  }

  setLineClamp() {
    this.contentTarget.style.setProperty("--line-clamp", this.linesValue);
  }

  checkIfClampingNeeded() {
    const content = this.contentTarget;
    const button = this.buttonTarget;

    if (!content.textContent.trim()) {
      content.classList.remove("clamped");
      content.style.removeProperty("max-height");
      button.style.display = "none";
      return;
    }

    content.classList.remove("clamped");
    content.style.removeProperty("max-height");
    const fullHeight = content.scrollHeight;

    content.classList.add("clamped");
    const clampedHeight = content.getBoundingClientRect().height;
    const needsClamping = fullHeight > Math.ceil(clampedHeight);
    this.fullHeight = fullHeight;
    this.clampedHeight = clampedHeight;

    if (needsClamping) {
      button.style.display = "inline";
      this.collapse();
    } else {
      content.classList.remove("clamped");
      content.style.removeProperty("max-height");
      button.style.display = "none";
    }
  }

  toggle() {
    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    const content = this.contentTarget;
    const button = this.buttonTarget;

    this.expanded = true;
    content.classList.remove("clamped");
    content.style.maxHeight = `${content.scrollHeight}px`;
    button.textContent = button.dataset.seeLessText || button.textContent;
    button.setAttribute("aria-expanded", "true");
  }

  collapse() {
    const content = this.contentTarget;
    const button = this.buttonTarget;

    this.expanded = false;
    content.classList.add("clamped");
    if (this.clampedHeight) {
      content.style.maxHeight = `${this.clampedHeight}px`;
    }
    button.textContent = button.dataset.seeMoreText || button.textContent;
    button.setAttribute("aria-expanded", "false");
  }
}
